import { render, staticRenderFns } from "./CockpitBudgetPainel.vue?vue&type=template&id=ec29e2e2&scoped=true"
import script from "./CockpitBudgetPainel.vue?vue&type=script&lang=js"
export * from "./CockpitBudgetPainel.vue?vue&type=script&lang=js"
import style0 from "./CockpitBudgetPainel.vue?vue&type=style&index=0&id=ec29e2e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec29e2e2",
  null
  
)

export default component.exports